import styled from 'styled-components';
import DocsTaskDetail from './DocsTaskDetail';

export default styled(DocsTaskDetail)`
  .docs-task-detail {
    display: flex;

    &__document-container {
      width: 100%;
    }

    &__loading,
    &__error {
      display: flex;
      justify-content: center;
      margin: 2rem 0;
      width: 100%;
    }

    &__document-actions {
      background-color: var(--white);
      display: flex;
      justify-content: space-between;
      padding: 1rem 5rem;
    }

    &__actions-container {
      display: flex;
      flex-grow: 1;
      margin-right: 2rem;

      &--buttons {
        align-items: flex-end;
        display: flex;
        justify-content: flex-end;
        padding-bottom: 2rem;
      }

      &:last-of-type {
        margin-right: 0;
      }
    }

    &__select-container {
      display: flex;
      flex-basis: 50%;
      flex-direction: column;
      padding-bottom: 2rem;
    }

    &__notify-container {
      margin-right: 2rem;
    }

    &__select-label {
      color: var(--grey500);
      margin-bottom: 1rem;
    }

    &__date-container {
      flex-basis: 50%;
      margin-left: 2rem;

      input {
        height: 32px;
      }
    }

    &__iban-container {
      flex-basis: 50%;
      width: 40rem;
      margin-left: 2rem;
      margin-top: 2.8rem;

      input {
        height: 32px;
      }
    }

    &__iban-field {
      width: 100%;

      input {
        height: 32px;
        width: 100%;  
      }
    }

    &__insurance-coverage {
      flex-basis: 50%;
      width: 40rem;
      margin-left: 2rem;
      margin-top: 2.8rem;

      input {
        height: 32px;
      }
    }

    &__insurance-coverage-field {
      width: 70%;

      input {
        height: 32px;
        width: 100%;  
        ::-webkit-inner-spin-button{
          -webkit-appearance: none; 
          margin: 0; 
        }
        ::-webkit-outer-spin-button{
            -webkit-appearance: none; 
            margin: 0; 
        }   
      }
    }

    &__actions-date {
      height: 32px;
    }

    &__doc-viewer-actions {
      display: flex;
      justify-content: flex-end;
      align-items: center
      padding: 2rem 5rem 0rem;
    }

    &__metadata {
      width: 100%;
      font-size: 1.4rem;
      display: flex;
      justify-content: flex-start;
    }

    &__metadata-page-count {
      width: 100%;
      font-size: 1.4rem;
      display: flex;
      justify-content: flex-end;
    }

    &__metadata-text {
      padding: 0rem 2rem;
    }

    &__viewer-container {
      display: flex;
      height: 100%;
      justify-content: center;
      padding: 2rem 5rem;
    }

    &__viewer {
      flex-grow: 1;
      max-width: 100%;
      min-height: 800px;
    }

    &__actions-button {
      margin-right: 2rem;
      svg {
        height: 24px;
        width: 24px;
      }

      &:last-of-type {
        margin-right: 0;
      }
    }

    &__reject-reason-field {
      margin-bottom: 2rem;
      width: 100%;
    }

    &__reject-reason-actions {
      display: flex;
      justify-content: flex-end;
    }

    &__warning-alert {
      align-items: center;
      color: var(--accent700);
      display: flex;
      margin: .8rem 0;
      svg {
        fill: var(--accent700);
        margin-right: .4rem;
      }
    }
  }
`;
